<script>
    import ContainerBgImageHeadlineAndSubtitle from "$lib/components/Container_bg_image_headline_and_subtitle.svelte";
    import ContainerBgImageHeadlineAndSubtitleSuggested from "$lib/components/Container_bg_image_headline_and_subtitle_suggested.svelte";
    import "../../../../../app.css";
    import { t } from "$lib/i18n.js";
</script>

<section>
    <div>
        <h2 class="accent">{$t('routes.owner.ways_of_sharing.title_first_line')}</h2>
        <h2>{$t('routes.owner.ways_of_sharing.title_second_line')}</h2>
    </div>

    <div class="options">
        <ContainerBgImageHeadlineAndSubtitle 
            headline="{$t('routes.owner.ways_of_sharing.cols.1.headline')}"
            subheadline={$t('routes.owner.ways_of_sharing.cols.1.subheadline')}
            image="https://assets.auting.it/images/photos/passing_keys.webp"
        />
        <ContainerBgImageHeadlineAndSubtitleSuggested 
            headline="{$t('routes.owner.ways_of_sharing.cols.2.headline')}"
            subheadline={$t('routes.owner.ways_of_sharing.cols.2.subheadline')}
            image="https://assets.auting.it/images/photos/phone_windows.webp"
            linkUrl="https://auting.it/connect"
            target="_self"
        />
    </div>
</section>

<style>
    section {
        padding-top: 140px;
        padding-bottom: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 48px;
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: center;
        font-family: var(--font-body);
        font-size: 56px;
    }

    h2.accent {
        color: var(--water-green);
        font-family: var(--font-heading);
        font-size: 74px;
        margin-bottom: 8px;
    }

    .options {
        max-width: var(--max-width);
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    @media (max-width: 768px) {
        section {
            margin-left: 16px;
            margin-right: 16px;
        }
        .options {
            flex-direction: column;
            align-items: center;
        }

        h2 {
            font-size: 40px;
            letter-spacing: -2px;
        }

        h2.accent {
            font-size: 56px;
            margin-bottom: 0px;
        }
    }
</style>
